import { ActivityTagPill } from "PFApp/components/activity_tag_pill";
import { Inline } from "PFComponents/containers";
import { getActivityCustomFieldValues } from "PFCore/helpers/activity_custom_fields";
import { Activity } from "PFCore/types";

import { ACTIVITY_TAG_ID, useManageTagsPermissions } from "./use_manage_tags_permissions";

type TagSectionProps = {
  activity: Activity;
};

export const TagSection = ({ activity }: TagSectionProps) => {
  const { canReadTags } = useManageTagsPermissions({
    isCoowned: activity.coowned,
    profile: activity.profile,
    templateId: activity.template_id
  });

  const currentTagName = getActivityCustomFieldValues(activity, ACTIVITY_TAG_ID)?.[0]?.value;

  if (!canReadTags || !currentTagName) {
    return null;
  }

  return (
    <Inline>
      <ActivityTagPill tagName={String(currentTagName)} />
    </Inline>
  );
};
